import { Surface } from '../../../../specification/Surface';
import { LevelGranulometryInitialEntries } from '../../LevelGranulometry';

export const getLevelAlreadyCalculatedRealBuiltSurface = (
  levelGranulometry: LevelGranulometryInitialEntries
): Surface => new Surface(levelGranulometry.realBuiltSurface || 0);
